// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen';
export class PersonasService {
    /**
     * Starts background persona generation. Creates a processing stub synchronously, dispatches the creation workflow in the background, and returns 202 with status `processing`.
     */
    static generate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/actions/generate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get all personas
     */
    static get(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas',
            ...options
        });
    }
    /**
     * Create a new persona
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Create a minimal persona stub in processing status for background audience generation
     */
    static createProcessingStub(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/processing-stub',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get multiple personas by IDs
     */
    static findMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/by-ids',
            ...options
        });
    }
    /**
     * Delete persona by ID
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/{id}',
            ...options
        });
    }
    /**
     * Get persona by ID
     */
    static findOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/{id}',
            ...options
        });
    }
    /**
     * Update persona by ID
     */
    static update(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get the workspaces a persona is shared with
     */
    static getWorkspaces(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/{id}/workspaces',
            ...options
        });
    }
    /**
     * Share or unshare a persona across workspaces of its own organization
     */
    static updateWorkspaces(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/personas/{id}/workspaces',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ExternalPersonasService {
    /**
     * List personas by organization (service-to-service)
     *
     * Lists personas for a given organization and optionally workspace. Only available for service-to-service (client credential) tokens.
     */
    static listPersonas(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/external/organizations/{organizationId}/personas',
            ...options
        });
    }
}
export class FocusGroupsService {
    /**
     * List focus groups for the workspace
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/focus-groups',
            ...options
        });
    }
    /**
     * Create a focus group
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/focus-groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a focus group
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/focus-groups/{id}',
            ...options
        });
    }
    /**
     * Get a focus group by ID
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/focus-groups/{id}',
            ...options
        });
    }
    /**
     * Update the title of a focus group
     */
    static updateTitle(options) {
        return (options.client ?? client).patch({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/focus-groups/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update a focus group
     */
    static update(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/focus-groups/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ContentTestsService {
    /**
     * List content tests for the workspace
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests',
            ...options
        });
    }
    /**
     * Create a draft content test
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a content test
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}',
            ...options
        });
    }
    /**
     * Get a content test by ID
     */
    static findOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}',
            ...options
        });
    }
    /**
     * Update a content test. Used by both user-facing flows and the orchestrator write-back.
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Bulk-write frozen persona snapshots for the test (orchestrator write-back).
     */
    static setPersonaSnapshots(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}/personas/snapshot',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Write the per-persona evaluation result or error (orchestrator write-back).
     */
    static updatePersonaResult(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}/personas/{personaId}/result',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class WorkspaceResolutionService {
    /**
     * Resolve a focus group id to its owning workspace and organization
     *
     * Accepts the focus group id regardless of the selected workspace. Reveals organization identity only to members of that organization.
     */
    static resolveFocusGroupWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/focus-groups/{id}/resolve-workspace',
            ...options
        });
    }
    /**
     * Resolve a content test id to its owning workspace and organization
     *
     * Accepts the content test id regardless of the selected workspace. Reveals organization identity only to members of that organization.
     */
    static resolveContentTestWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/content-tests/{id}/resolve-workspace',
            ...options
        });
    }
}
export class GwiResearchService {
    /**
     * List a persona's GWI research Q&As for an entry point, most recent first
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/gwi-research-questions',
            ...options
        });
    }
    /**
     * Persist a GWI research Q&A for a persona
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/gwi-research-questions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a persona GWI research Q&A
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/gwi-research-questions/{id}',
            ...options
        });
    }
}
